import { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { StyledLoading } from '../components/molecules/Loading/styled';
import Image from '../components/atoms/Image';
import { removeFromLS } from '@utils/storage';

export default function Reload() {
  const [isReady, setReadyState] = useState(false);

  useEffect(() => {
    const timeoutid = setTimeout(() => {
      removeFromLS('auth');
      setReadyState(true);
    }, 2000);

    return () => {
      clearTimeout(timeoutid);
    };
  }, []);

  return (
    <>
      {
        isReady
          ? <Redirect to="/" />
          : (
            <StyledLoading>
              <Image
                src={`${process.env.PUBLIC_URL}/img/icon-hat.svg`}
                alt="logo"
                width={84}
              />
            </StyledLoading>
          )
      }
    </>

  );
}
